import styled from 'styled-components';

import { PeopleInAssetsColors } from './colors';

// Section components
const PeopleSection = styled.div`
  margin-top: 10px;
`;

const SectionHeader = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;

const HeaderText = styled.p`
  color: ${PeopleInAssetsColors.DarkText};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.175px;
  margin-right: 5px;
`;

const HeaderIcon = styled.span`
  color: ${PeopleInAssetsColors.MediumText};
  font-size: 14px;
  cursor: pointer;
`;

// Content components
const PeopleContent = styled.div`
  border-radius: 4px;
  border: 1px solid ${PeopleInAssetsColors.LightBorder};
  background: ${PeopleInAssetsColors.White};
  display: flex;
  width: 100%;
  padding: 16px;
  align-items: center;
`;

const PeopleTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
`;

// Person tag components
const PersonTag = styled.div`
  display: flex;
  align-items: center;
`;

const PersonImage = styled.div`
  width: 48px;
  height: 48px;
  margin-right: 10px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
`;

const PersonName = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${PeopleInAssetsColors.White};
  border: 1px solid ${PeopleInAssetsColors.LightBorder};
  border-radius: 4px;
  padding: 0 12px;
  min-width: 150px;
  width: 200px;
  position: relative;
  height: 48px;

`;

const PersonNameText = styled.p`
  font-size: 14px;
  margin: 0;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const RemovePersonButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 8px;
  padding: 4px;

  .icon {
    font-size: 16px;
    color: ${PeopleInAssetsColors.MediumText};
  }

  &:hover .icon {
    color: ${PeopleInAssetsColors.DarkText};
  }
`;

// Dropdown components
const CustomDropdown = styled.div`
  width: 100%;
`;

const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
`;

const SelectedOption = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
`;

const OptionImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
  object-fit: cover;
`;

const OptionText = styled.span`
  font-size: 14px;
  color: ${PeopleInAssetsColors.DarkText};
`;

const Placeholder = styled.span`
  font-size: 14px;
  color: ${PeopleInAssetsColors.MediumText};
`;

const DropdownIcon = styled.span`
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  position: absolute;
  right: 5%;
  .icon {
    font-size: 16px;
    color: ${PeopleInAssetsColors.MediumText};
  }

  &:hover .icon {
    color: ${PeopleInAssetsColors.DarkText};
  }
`;

const DropdownOptions = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: ${PeopleInAssetsColors.White};
  border: 1px solid ${PeopleInAssetsColors.LightBorder};
  border-radius: 4px;
  z-index: 10;
  margin-top: 4px;
  box-shadow: 0 2px 4px ${PeopleInAssetsColors.BoxShadow};
`;

const DropdownOption = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background: ${PeopleInAssetsColors.LightGrayBackground};
  }
`;

const InputStyled = styled.input`
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  padding-right: 20px;
  width: 90%;
`;

// Face thumbnail image
const FaceThumbnailImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 4px;
  display: block;
  object-fit: cover;
`;

// Wrapper component that contains everything
const Wrapper = styled.div``;

export {
  PeopleSection,
  SectionHeader,
  HeaderText,
  HeaderIcon,
  PeopleContent,
  PeopleTagsContainer,
  PersonTag,
  PersonImage,
  PersonName,
  PersonNameText,
  RemovePersonButton,
  CustomDropdown,
  DropdownHeader,
  SelectedOption,
  OptionImage,
  OptionText,
  Placeholder,
  DropdownIcon,
  DropdownOptions,
  DropdownOption,
  InputStyled,
  FaceThumbnailImage
};

export default Wrapper;
